import { Button, FormGroup, Grid, TextField } from "@mui/material";
import WindowPattern from "../../../../Components/Patterns/Window";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function AddThirdPartyPlea () {

    return (
        <WindowPattern path="V.I | Pleito - Orçamento - Cronograma Financeiro - Novo Terceiro" style={{ height: '58vh' }}>

            <FormGroup style={{ height: '435px', justifyContent: 'center', display: 'flex', margin: '0px 50px' }}>

                <Grid container spacing={2}>

                    <Grid item md={6}>
                        <TextField
                            fullWidth
                            required
                            label="Rubrica"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={6}>
                        <TextField
                            fullWidth
                            required
                            label="Nome do Fornecedor"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={12}>
                        <TextField
                            fullWidth
                            required
                            label="Descrição da Atividade"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            required
                            label="Alocação no Projeto (%)"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            required
                            label="Meses de Trabalho Realizado"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={4}>
                        <TextField
                            fullWidth
                            label="Valor Mensal Financeiro"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={5}>
                        <TextField
                            fullWidth
                            required
                            label="Beneficios"
                            placeholder="R$"
                        />
                    </Grid>

                    <Grid item md={5}>
                        <TextField
                            fullWidth
                            label="Encargos"
                            placeholder="Digite aqui..."
                        />
                    </Grid>

                    <Grid item md={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker sx={{ width: '100%', background: 'var(--color-white)' }} label="Data de Geração" />
                        </LocalizationProvider>
                    </Grid>

                    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', margin: '25px 0px' }}>
                        <Button variant="contained" style={{ background: 'var(--color-blue)' }}>Salvar</Button>
                    </div>

                </Grid>

            </FormGroup>

        </WindowPattern>
    )
}